export const transitionEmail = {
  profileToScreeningCall: {
    emailSubject: "Teamo Recruitment: Welcome to Screening Call Phase",
    emailBody:
      'Dear candidate,\n\nYou have successfully passed our Profile creation stage on the Teamo Recruitment Portal. The completion of profile on the portal leads you to the next phase of our recruitment process i.e., "Screening Interview". You are now eligible to schedule a screening call with our team. \n\nKindly access your dashboard and pick a suitable time slot to meet our hiring team for your screening interview.\nYour active participation is valued.\n\n Warm Regards,\nTeamo',
  },
};
